import { ResourceObject } from '../api_primitives'

export interface ConversationWarning {
  attribute: string
  fullMessage: string
}

export interface ConversationValidateResource extends ResourceObject {
  type: 'ConversationValidate'
  warnings: ConversationWarning[]
}
